import Vue from 'vue';
import VCalendar from 'v-calendar';

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  locales: {
    'pt-PT': {
      masks: {
        L: 'DD-WWW-MMM'
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/plugins/vcalendar.plugin.js